import { useTranslation } from "react-i18next";

const ContainerSettingsHeader = ({ onSort, sortByField, orderSortByField }) => {
  const { t } = useTranslation();

  const handleSort = (field) => {
    if (onSort) {
      // Si on clique sur la même colonne, on alterne l'ordre
      if (sortByField === field) {
        onSort(field, orderSortByField === "1" ? "-1" : "1");
      } else {
        // Sinon, on trie par défaut en croissant
        onSort(field, "1");
      }
    }
  };

  const getSortIcon = (field) => {
    if (sortByField === field) {
      // Affiche la flèche correspondant à l'ordre actuel
      return orderSortByField === "1" ? "fa-sort-up" : "fa-sort-down";
    }
    // Par défaut, affiche les deux flèches superposées
    return "fa-sort";
  };

  return (
    <article className="table-standard-header">
      <div
        className="table-standard-header-cell table-standard-cell-align-left"
        style={{ cursor: "pointer" }}
        onClick={() => handleSort("addressName")}
      >
        {t("Address")}
        <span className="sort-icon">
          <i className={`fas ${getSortIcon("addressName")}`}></i>
        </span>
      </div>
      <div
        className="table-standard-header-cell table-standard-cell-align-left"
        style={{ cursor: "pointer" }}
        onClick={() => handleSort("wasteName")}
      >
        {t("Waste Category")}
        <span className="sort-icon">
          <i className={`fas ${getSortIcon("wasteName")}`}></i>
        </span>
      </div>
      <div className="table-standard-header-cell table-standard-cell-align-left">
        {t("Type")}
      </div>
      <div className="table-standard-header-cell table-standard-cell-align-left">
        {t("containerSettings.activeModules")}
      </div>
      <article className="table-standard-header-cell"></article>
    </article>
  );
};

export default ContainerSettingsHeader;
